import { TreeOptions, TreeAdapter, TreeSource } from "@omegagrid/tree";
import rp, { SqlParameterListAdapter} from "@reporting/rp-app-host";
import { Parameter } from "@reporting/rp-types/etl";
import { Query } from "@reporting/rp-types/ext";

export class QueryParameterTreeAdapter extends TreeAdapter {

	private data: TreeSource;

	constructor(private parameter: Parameter) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.data) return this.data;

		try {
			this.data = await rp.ms('extensions').get<TreeSource>(`parameterContent/${this.parameter.idz}`);
			return this.data;
		} catch (error) {
			return [
				{k: null, v: error, icon: {icon: "hexagon-exclamation", color: 'red'}}
			];
		}
	}

	getOptions(): Partial<TreeOptions> {
		const multiselect = /^table/.test(this.parameter.data_type);
		return {
			selectMode: multiselect ? 'multiple' : 'single',
			autoClose: !multiselect,
			allowEmpty: true
		};
	}

}


export class QuerySqlParameterListAdapter extends SqlParameterListAdapter {

	constructor(private query: Query) { super() }

	async getParameters(): Promise<Parameter[]> {
		return rp.ms('extensions').get(`queries/${this.query.id_thread}/parameters`);
	}

	async delete(parameter: Parameter) {
		await rp.ms('extensions').delete(`parameters/${parameter.idz}`);
	}

	isReadonly(): boolean { return false }

	getParentId() {
		return this.query.id_thread;
	}

	getTreeAdapter(parameter: Parameter) : TreeAdapter {
		return new QueryParameterTreeAdapter(parameter);
	}

	createComponentId(type: 'form'|'contentEditor'|'valueEditor', parameter?: Parameter): string {
		switch (type) {
			case 'form': return `extensions-parameterForm-${parameter ? `${parameter.id_thread}-${parameter.idz}` : this.query.id_thread}`;
			case 'contentEditor': return `extensions-parameterContent-${parameter.idz}`;
			case 'valueEditor': return `extensions-parameterValue-${parameter.idz}`;
		}
	}

}
